import { render, staticRenderFns } from "./ClassTimeTable.vue?vue&type=template&id=d44265e6&scoped=true&"
import script from "./ClassTimeTable.vue?vue&type=script&lang=js&"
export * from "./ClassTimeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44265e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
